import { createPersistedState } from '@plq/use-persisted-state'
import storage from '@plq/use-persisted-state/lib/storages/local-storage'

export const [useLocalStorageState] = createPersistedState('aims', storage)
